import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ReportChecksheetBaseService } from './report-checksheet-base.service';

@Injectable()
export class ReportChecksheetService extends ReportChecksheetBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
